import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material';
import AuthContainer from './containers/AuthContainer';
import { BASE_URL } from "./components/shared/Links";

ReactDOM.createRoot(document.getElementById('root')).render(
    <ThemeProvider theme={createTheme()}>
        <AuthContainer useStatus appBase={BASE_URL} />
    </ThemeProvider>
);